<div class ="wave">
    <svg style="height: 100%;" [attr.fill]="fillColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path [attr.fill]="fillColor" fill-opacity="1" d="M0,96L80,85.3C160,75,320,53,480,58.7C640,64,800,96,960,96C1120,96,1280,64,1360,48L1440,32L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path></svg>
</div>

<section class="section">
    <div style="margin-top: 50px; display: flex; flex-direction: column; justify-content: center;align-items: center;">
        <img class="image" [src]="image" alt="logo">
        <div style="text-align: center; padding: 20px;" class="w-full flex flex-column align-items-center ">
            <span style="color: var(--color-primario)" class="font-title-bold text-8xl ">{{code}}</span>
            <h1 class="text-900 font-bold text-2xl lg:text-5xl mb-2">{{title}}</h1>
            <div class="text-600 mb-5">{{subtitle}}</div>
        </div>
    </div>
</section>
